module.exports = __webpack_public_path__ + "img/upsidedown.aa67fb05.png";